import { render, staticRenderFns } from "./modalCambiarPosicionImagen.vue?vue&type=template&id=b4f4ee7a&"
import script from "./modalCambiarPosicionImagen.vue?vue&type=script&lang=js&"
export * from "./modalCambiarPosicionImagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports